import React from 'react';
import MetaTags from "../components/MetaTags";

const Home: React.FC = () =>  {

    MetaTags(
        "Искусство бисероплетения",
        "Изделия из бисера: браслеты, колье, бусы. Схемы плетения, уроки. Цветы, фенечки, брелки и аксессуары из бисера и стекляруса. Нашивки для отделки одежды."
    )

    return <>

        <p><strong>Добро пожаловать.</strong> На данном сайте вы можете ознакомится с изделиями из бисера, заказать себе
            или кому-то в подарок оригинальное украшение. Найти схемы и рекомендации для создания собственного изделия.
        </p>

        <p>Украшения из бисера могут быть яркими, блестящими, сверкать всеми цветами радуги.</p>
        <p>Бисер&nbsp;— материал очень красивый, яркий, разнообразный. Он бывает разных размеров, форм, расцветок.</p>

        <p>Яркие бусинки помогут украсить одежду, интерьер, создать необыкновенные украшения, подарки, сувениры, игрушки
            и многое другое.</p>
        <p>В умелых руках и с богатой фантазией он может превратиться во что-то волшебное и неповторимое.</p>

        <p>Творчество может помочь справиться с плохим настроением, депрессией, развить воображение, терпение,
            фантазию.</p>

        <p>Еще очень интересно делать цветы из бисера, бусин, стекляруса. Из них можно составлять веточки, букеты,
            браслеты, потрясающие колье.</p>
        <p>Цветы из бисера могут быть самыми разнообразными&nbsp;— большими и маленькими, круглыми и с зубчатыми
            лепестками, с бусинами и стеклярусом. Ими можно украшать одежду, делать веточки и деревья, браслеты и колье
            и даже использовать в интерьере.</p>

        <p>Букеты, веточки и деревья из бисера придадут домашнему интерьеру живость, яркость ощущение праздника, станут
            оригинальным подарком, сделают одежду изысканной, индивидуальной и неповторимой.</p>
    </>;
};

export default Home;